var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2K(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 997.23,
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ea2228",
    d: "M 0,0 H 1000 V 997.22992 H 0 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M 836.5651,465.2687 H 678.72853 L 534,570.4072 568.29501,465.2687 H 315.51662 c 10.99169,-11.24515 27.16493,-17.933 54.68837,-22.75346 l 115.72853,-20.2687 C 532.02,414.17495 598.7055,391.41488 617.02355,334.76316 643.99085,251.36214 556.5097,234.07202 457.33241,234.07202 c -76.93213,0 -181.14266,13.7313 -223.51385,116.38366 h 130.55956 c 16.02216,-38.70776 50.44875,-41.71468 83.55263,-41.71468 28.33656,0 47.35126,6.91358 41.84349,24.06094 -4.02693,12.53705 -14.86919,20.07048 -30.98477,23.27562 l -95.33795,18.96122 C 286.23864,390.39521 201.37673,425.25346 162.04986,539.93767 H 424.759 l -72.29917,223.22022 h 119.17313 l 25.95291,-80.02908 50.31718,-34.26177 45.41828,114.29085 H 751.68698 L 664.69252,580.47507 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2K);
export default __webpack_public_path__ + "static/media/2k.d9d3d1aa4bca6afed8e475c7bc57125e.svg";
export { ForwardRef as ReactComponent };